import { render, staticRenderFns } from "./SetCategory.vue?vue&type=template&id=f621d8d8&scoped=true"
import script from "./SetCategory.vue?vue&type=script&lang=js"
export * from "./SetCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f621d8d8",
  null
  
)

export default component.exports